import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { SignalRService } from '../services/signalr-service';
import { SessionService } from 'src/app/services/session.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TeamsStyleSnackbarComponent } from '../teams-style-snackbar/teams-style-snackbar.component';


@Component({
    selector: 'app-chatroom-window',
    templateUrl: './chatroom-window.component.html',
    styleUrls: ['./chatroom-window.component.scss'],
    standalone: false
})
export class ChatroomWindowComponent implements OnInit, OnChanges {

  message = '';
  messages: { user: string; message: string , userDetails:any}[] = [];
  @Input("userDetails") userDetails:any;
  
  constructor(
    private signalRService: SignalRService,
    private sessionService: SessionService,
    private _snackBar: MatSnackBar // <-- Inject MatSnackBar
  ) {}
  
  ngOnChanges(changes: SimpleChanges): void {
    if(changes['userDetails'].currentValue != changes['userDetails'].previousValue) {
      this.userDetails = changes['userDetails'].currentValue;
    }
  }

  ngOnInit(): void {
    // Subscribe to incoming messages
    // this.signalRService.onReceiveMessage((user: string, message: string) => {
    //   let userDetails = {};
    //   this.messages.push({ user, message, userDetails });
    //   console.log(this.messages);

    //   // Check for system reminder message
    //   if (user === 'System' && message.startsWith('Reminder:')) {
    //     this.openTeamsStyleSnackbar(message);
    //   }
    // });
  }

  sendMessage() {
    if (!this.message.trim()) return; // Prevent sending empty messages
    let user = this.sessionService.getUsername();
    let userName = this.userDetails ? this.userDetails.user_id : "";
    let userDetails = {};
    let message = this.message
    this.messages.push({ user, message, userDetails });
    // Send the message via SignalRService
    this.signalRService.sendMessage(user, userName, this.message);
    this.message = ''; // Clear the input after sending
  }

  // openTeamsStyleSnackbar(message: string) {
  //   this._snackBar.openFromComponent(TeamsStyleSnackbarComponent, {
  //     data: {
  //       title: 'Reminder',
  //       time: new Date().toLocaleTimeString(),
  //       description: message.replace('Reminder:', '').trim()
  //     },
  //     panelClass: ['teams-snackbar-panel'],
  //     duration: 90000000,
  //     horizontalPosition: 'end',
  //     verticalPosition: 'bottom',
  //   });
  // }
}